import { ElevatedSurface, IconButton, RotateCwIcon } from "@carbon6/c6-frontend-design";
import type { Probe } from "../../domain/probe";
import { probeFailureView } from "../../feature/probeFailureMessage";
import cardStyles from "./DetailCard.module.css";
import styles from "./ProbeFailureCard.module.css";

type ProbeFailureCardProps = {
  probe: Probe;
  onRetry: () => void;
};

/**
 * 실패 사유와 다음 행동.
 *
 * `failure_detail` 은 서버 원문(영어 기술 문장)이라 기본으로 접어 둔다 — 필요한 사람만 펼친다
 * (규칙 §5).
 */
export function ProbeFailureCard({ onRetry, probe }: ProbeFailureCardProps) {
  const view = probeFailureView(probe.failureCode);

  return (
    <ElevatedSurface as="section" className={cardStyles.card} elevation={1} hoverElevation={false}>
      <h3 className={cardStyles.title}>실패 사유</h3>
      <p className={styles.message}>{view.message}</p>
      <p className={styles.nextAction}>{view.nextAction}</p>
      {probe.failureDetail === null ? null : (
        <details className={styles.details}>
          <summary className={styles.summary}>기술 정보</summary>
          <pre className={styles.detail}>{probe.failureDetail}</pre>
        </details>
      )}
      <div className={styles.actions}>
        <IconButton text="Probe 다시 요청" tone="primary" variant="surface" onClick={onRetry}>
          <RotateCwIcon />
        </IconButton>
      </div>
    </ElevatedSurface>
  );
}
